"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NACE_SERH = exports.NACE_TEHLIKE_SINIFI = void 0;
exports.NACE_TEHLIKE_SINIFI = {
    '01.11.07': 'hazardous',
    '01.11.12': 'hazardous',
    '01.11.14': 'hazardous',
    '01.12.14': 'hazardous',
    '01.13.17': 'hazardous',
    '01.13.18': 'hazardous',
    '01.13.19': 'hazardous',
    '01.13.20': 'hazardous',
    '01.13.21': 'hazardous',
    '01.13.22': 'hazardous',
    '01.13.23': 'hazardous',
    '01.14.01': 'hazardous',
    '01.15.01': 'hazardous',
    '01.16.02': 'hazardous',
    '01.16.90': 'hazardous',
    '01.19.01': 'hazardous',
    '01.19.02': 'hazardous',
    '01.19.99': 'hazardous',
    '01.21.05': 'hazardous',
    '01.22.05': 'hazardous',
    '01.23.02': 'hazardous',
    '01.24.04': 'hazardous',
    '01.25.09': 'hazardous',
    '01.25.90': 'hazardous',
    '01.26.02': 'hazardous',
    '01.26.90': 'hazardous',
    '01.27.02': 'hazardous',
    '01.27.90': 'hazardous',
    '01.28.01': 'hazardous',
    '01.29.01': 'hazardous',
    '01.30.03': 'low_risk',
    '01.30.90': 'low_risk',
    '01.41.31': 'hazardous',
    '01.42.09': 'hazardous',
    '01.43.01': 'hazardous',
    '01.44.01': 'hazardous',
    '01.45.01': 'hazardous',
    '01.46.01': 'hazardous',
    '01.47.01': 'hazardous',
    '01.47.02': 'hazardous',
    '01.47.03': 'hazardous',
    '01.48.01': 'hazardous',
    '01.48.02': 'hazardous',
    '01.48.03': 'hazardous',
    '01.48.99': 'hazardous',
    '01.50.06': 'hazardous',
    '01.61.01': 'hazardous',
    '01.61.02': 'hazardous',
    '01.61.03': 'hazardous',
    '01.61.04': 'highly_hazardous',
    '01.61.05': 'hazardous',
    '01.61.06': 'highly_hazardous',
    '01.62.01': 'hazardous',
    '01.62.02': 'hazardous',
    '01.63.01': 'hazardous',
    '01.63.02': 'hazardous',
    '01.63.03': 'hazardous',
    '01.63.04': 'hazardous',
    '01.63.05': 'low_risk',
    '01.63.06': 'hazardous',
    '01.63.07': 'hazardous',
    '01.63.08': 'hazardous',
    '01.63.90': 'hazardous',
    '01.70.01': 'hazardous',
    '01.70.02': 'hazardous',
    '02.10.01': 'hazardous',
    '02.10.02': 'low_risk',
    '02.10.03': 'low_risk',
    '02.20.01': 'hazardous',
    '02.30.01': 'low_risk',
    '02.40.01': 'hazardous',
    '02.40.02': 'hazardous',
    '02.40.03': 'hazardous',
    '02.40.04': 'highly_hazardous',
    '02.40.05': 'hazardous',
    '02.40.06': 'hazardous',
    '02.40.90': 'low_risk',
    '03.11.01': 'hazardous',
    '03.11.02': 'highly_hazardous',
    '03.12.01': 'hazardous',
    '03.21.01': 'hazardous',
    '03.21.02': 'hazardous',
    '03.22.01': 'low_risk',
    '03.22.02': 'hazardous',
    '03.30.01': 'hazardous',
    '03.30.02': 'hazardous',
    '06.10.01': 'highly_hazardous',
    '06.20.01': 'highly_hazardous',
    '07.21.01': 'highly_hazardous',
    '07.21.02': 'highly_hazardous',
    '07.21.03': 'highly_hazardous',
    '07.21.04': 'highly_hazardous',
    '07.21.05': 'highly_hazardous',
    '07.29.01': 'highly_hazardous',
    '07.29.02': 'highly_hazardous',
    '07.29.03': 'highly_hazardous',
    '07.29.04': 'highly_hazardous',
    '07.29.05': 'highly_hazardous',
    '07.29.06': 'highly_hazardous',
    '07.29.99': 'highly_hazardous',
    '08.11.01': 'highly_hazardous',
    '08.11.02': 'highly_hazardous',
    '08.11.03': 'highly_hazardous',
    '08.11.04': 'highly_hazardous',
    '08.11.05': 'highly_hazardous',
    '08.11.06': 'highly_hazardous',
    '08.11.07': 'highly_hazardous',
    '08.12.01': 'highly_hazardous',
    '08.12.02': 'highly_hazardous',
    '08.12.03': 'highly_hazardous',
    '08.91.01': 'highly_hazardous',
    '08.91.02': 'highly_hazardous',
    '08.91.03': 'highly_hazardous',
    '08.91.04': 'highly_hazardous',
    '08.91.05': 'highly_hazardous',
    '08.93.01': 'highly_hazardous',
    '08.93.02': 'hazardous',
    '08.99.01': 'highly_hazardous',
    '08.99.02': 'highly_hazardous',
    '08.99.03': 'highly_hazardous',
    '08.99.04': 'highly_hazardous',
    '08.99.05': 'highly_hazardous',
    '09.10.01': 'highly_hazardous',
    '09.10.02': 'highly_hazardous',
    '09.10.03': 'highly_hazardous',
    '09.90.01': 'hazardous',
    '09.90.02': 'highly_hazardous',
    '10.11.01': 'hazardous',
    '10.12.01': 'hazardous',
    '10.12.02': 'hazardous',
    '10.12.03': 'hazardous',
    '10.12.04': 'hazardous',
    '10.13.01': 'hazardous',
    '10.13.02': 'hazardous',
    '10.13.03': 'hazardous',
    '10.13.04': 'hazardous',
    '10.20.03': 'hazardous',
    '10.20.04': 'hazardous',
    '10.20.05': 'hazardous',
    '10.20.06': 'hazardous',
    '10.20.07': 'hazardous',
    '10.20.08': 'hazardous',
    '10.31.01': 'hazardous',
    '10.31.02': 'hazardous',
    '10.32.01': 'low_risk',
    '10.32.02': 'low_risk',
    '10.39.01': 'hazardous',
    '10.39.02': 'low_risk',
    '10.39.03': 'low_risk',
    '10.39.04': 'low_risk',
    '10.39.05': 'low_risk',
    '10.39.06': 'low_risk',
    '10.39.07': 'hazardous',
    '10.39.99': 'low_risk',
    '10.41.01': 'hazardous',
    '10.41.02': 'hazardous',
    '10.41.05': 'hazardous',
    '10.41.07': 'hazardous',
    '10.41.10': 'hazardous',
    '10.41.11': 'hazardous',
    '10.42.01': 'hazardous',
    '10.51.01': 'hazardous',
    '10.51.02': 'hazardous',
    '10.51.03': 'hazardous',
    '10.51.04': 'hazardous',
    '10.51.90': 'hazardous',
    '10.52.01': 'low_risk',
    '10.52.02': 'low_risk',
    '10.61.01': 'low_risk',
    '10.61.02': 'hazardous',
    '10.61.05': 'hazardous',
    '10.61.06': 'hazardous',
    '10.61.07': 'hazardous',
    '10.61.08': 'hazardous',
    '10.61.09': 'low_risk',
    '10.61.90': 'low_risk',
    '10.62.01': 'hazardous',
    '10.62.02': 'hazardous',
    '10.62.04': 'hazardous',
    '10.62.05': 'hazardous',
    '10.62.06': 'hazardous',
    '10.71.01': 'low_risk',
    '10.71.02': 'low_risk',
    '10.71.03': 'low_risk',
    '10.71.04': 'low_risk',
    '10.72.01': 'low_risk',
    '10.72.02': 'low_risk',
    '10.72.03': 'low_risk',
    '10.81.01': 'hazardous',
    '10.81.03': 'hazardous',
    '10.82.01': 'low_risk',
    '10.82.02': 'low_risk',
    '10.82.03': 'low_risk',
    '10.82.04': 'low_risk',
    '10.82.05': 'low_risk',
    '10.82.06': 'low_risk',
    '10.82.07': 'low_risk',
    '10.83.01': 'low_risk',
    '10.83.02': 'low_risk',
    '10.83.03': 'low_risk',
    '10.83.04': 'low_risk',
    '10.84.01': 'low_risk',
    '10.84.02': 'hazardous',
    '10.84.03': 'hazardous',
    '10.84.05': 'low_risk',
    '10.85.01': 'low_risk',
    '10.86.04': 'low_risk',
    '10.89.01': 'low_risk',
    '10.89.02': 'hazardous',
    '10.89.04': 'low_risk',
    '10.89.05': 'hazardous',
    '10.89.99': 'low_risk',
    '10.91.01': 'hazardous',
    '10.92.01': 'hazardous',
    '11.01.01': 'highly_hazardous',
    '11.01.02': 'highly_hazardous',
    '11.01.03': 'highly_hazardous',
    '11.02.01': 'hazardous',
    '11.02.02': 'hazardous',
    '11.03.01': 'hazardous',
    '11.04.02': 'hazardous',
    '11.05.01': 'hazardous',
    '11.06.01': 'hazardous',
    '11.07.01': 'low_risk',
    '11.07.03': 'low_risk',
    '11.07.04': 'hazardous',
    '11.07.90': 'low_risk',
    '12.00.04': 'hazardous',
    '13.10.03': 'hazardous',
    '13.10.05': 'hazardous',
    '13.10.06': 'hazardous',
    '13.10.08': 'hazardous',
    '13.10.09': 'hazardous',
    '13.10.10': 'hazardous',
    '13.10.12': 'hazardous',
    '13.10.13': 'hazardous',
    '13.10.14': 'hazardous',
    '13.10.15': 'hazardous',
    '13.20.14': 'hazardous',
    '13.20.16': 'hazardous',
    '13.20.17': 'hazardous',
    '13.20.19': 'hazardous',
    '13.20.20': 'hazardous',
    '13.20.21': 'hazardous',
    '13.20.22': 'hazardous',
    '13.20.23': 'hazardous',
    '13.30.01': 'hazardous',
    '13.30.02': 'hazardous',
    '13.30.03': 'hazardous',
    '13.30.04': 'hazardous',
    '13.30.05': 'hazardous',
    '13.30.06': 'hazardous',
    '13.91.01': 'hazardous',
    '13.91.02': 'hazardous',
    '13.92.01': 'hazardous',
    '13.92.02': 'hazardous',
    '13.92.03': 'hazardous',
    '13.92.04': 'hazardous',
    '13.92.05': 'hazardous',
    '13.92.06': 'hazardous',
    '13.92.09': 'hazardous',
    '13.93.01': 'hazardous',
    '13.93.02': 'low_risk',
    '13.94.02': 'low_risk',
    '13.94.03': 'hazardous',
    '13.95.01': 'hazardous',
    '13.96.01': 'hazardous',
    '13.96.02': 'low_risk',
    '13.96.03': 'hazardous',
    '13.96.04': 'low_risk',
    '13.96.05': 'hazardous',
    '13.96.06': 'hazardous',
    '13.96.07': 'hazardous',
    '13.96.08': 'hazardous',
    '13.96.09': 'hazardous',
    '13.96.10': 'hazardous',
    '13.96.11': 'hazardous',
    '13.96.12': 'hazardous',
    '13.99.02': 'hazardous',
    '13.99.03': 'hazardous',
    '13.99.04': 'hazardous',
    '13.99.06': 'hazardous',
    '14.10.01': 'low_risk',
    '14.10.02': 'low_risk',
    '14.10.03': 'low_risk',
    '14.10.04': 'low_risk',
    '14.10.05': 'low_risk',
    '14.21.01': 'low_risk',
    '14.21.02': 'low_risk',
    '14.21.03': 'low_risk',
    '14.21.04': 'low_risk',
    '14.22.01': 'low_risk',
    '14.22.02': 'low_risk',
    '14.22.03': 'low_risk',
    '14.22.04': 'low_risk',
    '14.23.00': 'low_risk',
    '14.24.01': 'hazardous',
    '14.24.02': 'hazardous',
    '14.29.01': 'low_risk',
    '14.29.02': 'low_risk',
    '14.29.03': 'hazardous',
    '14.29.04': 'low_risk',
    '14.29.05': 'low_risk',
    '15.11.10': 'highly_hazardous',
    '15.11.11': 'highly_hazardous',
    '15.11.13': 'highly_hazardous',
    '15.11.14': 'highly_hazardous',
    '15.12.07': 'hazardous',
    '15.12.08': 'hazardous',
    '15.12.09': 'hazardous',
    '15.12.10': 'hazardous',
    '15.12.11': 'low_risk',
    '15.12.99': 'hazardous',
    '15.20.05': 'hazardous',
    '15.20.06': 'hazardous',
    '15.20.07': 'hazardous',
    '15.20.15': 'hazardous',
    '15.20.17': 'hazardous',
    '15.20.18': 'hazardous',
    '15.20.19': 'hazardous',
    '16.11.01': 'hazardous',
    '16.11.02': 'hazardous',
    '16.11.03': 'highly_hazardous',
    '16.11.04': 'hazardous',
    '16.12.00': 'highly_hazardous',
    '16.21.01': 'hazardous',
    '16.21.02': 'highly_hazardous',
    '16.22.01': 'hazardous',
    '16.23.02': 'hazardous',
    '16.23.99': 'hazardous',
    '16.24.02': 'hazardous',
    '16.24.90': 'hazardous',
    '16.25.00': 'hazardous',
    '16.26.00': 'hazardous',
    '16.27.00': 'hazardous',
    '16.28.01': 'low_risk',
    '16.28.02': 'hazardous',
    '16.28.03': 'hazardous',
    '16.28.04': 'low_risk',
    '16.28.05': 'low_risk',
    '16.28.06': 'low_risk',
    '16.28.99': 'hazardous',
    '17.11.08': 'hazardous',
    '17.12.07': 'hazardous',
    '17.21.10': 'hazardous',
    '17.21.11': 'hazardous',
    '17.21.12': 'hazardous',
    '17.21.13': 'hazardous',
    '17.22.02': 'hazardous',
    '17.22.03': 'hazardous',
    '17.22.04': 'hazardous',
    '17.23.04': 'hazardous',
    '17.23.06': 'hazardous',
    '17.23.07': 'hazardous',
    '17.23.08': 'hazardous',
    '17.23.09': 'hazardous',
    '17.24.02': 'hazardous',
    '17.24.03': 'hazardous',
    '17.25.01': 'hazardous',
    '17.25.02': 'hazardous',
    '17.25.03': 'hazardous',
    '17.25.99': 'hazardous',
    '18.11.01': 'hazardous',
    '18.12.01': 'hazardous',
    '18.12.02': 'hazardous',
    '18.12.03': 'hazardous',
    '18.12.04': 'hazardous',
    '18.12.06': 'hazardous',
    '18.12.07': 'hazardous',
    '18.12.08': 'low_risk',
    '18.12.99': 'low_risk',
    '18.13.01': 'highly_hazardous',
    '18.13.02': 'low_risk',
    '18.14.01': 'hazardous',
    '18.20.02': 'low_risk',
    '18.20.03': 'low_risk',
    '19.10.10': 'highly_hazardous',
    '19.10.11': 'highly_hazardous',
    '19.20.12': 'highly_hazardous',
    '19.20.15': 'highly_hazardous',
    '19.20.16': 'highly_hazardous',
    '19.20.17': 'highly_hazardous',
    '19.20.19': 'highly_hazardous',
    '20.11.01': 'highly_hazardous',
    '20.12.01': 'highly_hazardous',
    '20.12.02': 'highly_hazardous',
    '20.13.02': 'highly_hazardous',
    '20.13.03': 'highly_hazardous',
    '20.13.04': 'highly_hazardous',
    '20.13.06': 'highly_hazardous',
    '20.13.90': 'highly_hazardous',
    '20.13.99': 'highly_hazardous',
    '20.14.00': 'highly_hazardous',
    '20.15.01': 'highly_hazardous',
    '20.15.02': 'highly_hazardous',
    '20.16.01': 'highly_hazardous',
    '20.16.02': 'highly_hazardous',
    '20.16.03': 'highly_hazardous',
    '20.16.04': 'highly_hazardous',
    '20.16.05': 'highly_hazardous',
    '20.17.01': 'highly_hazardous',
    '20.20.11': 'highly_hazardous',
    '20.20.13': 'highly_hazardous',
    '20.20.15': 'highly_hazardous',
    '20.20.16': 'hazardous',
    '20.20.90': 'highly_hazardous',
    '20.30.11': 'highly_hazardous',
    '20.30.12': 'highly_hazardous',
    '20.30.14': 'highly_hazardous',
    '20.30.15': 'highly_hazardous',
    '20.30.16': 'highly_hazardous',
    '20.30.17': 'highly_hazardous',
    '20.30.90': 'highly_hazardous',
    '20.41.01': 'hazardous',
    '20.41.03': 'hazardous',
    '20.41.04': 'hazardous',
    '20.41.06': 'hazardous',
    '20.42.01': 'hazardous',
    '20.42.02': 'hazardous',
    '20.42.03': 'hazardous',
    '20.42.04': 'hazardous',
    '20.51.24': 'highly_hazardous',
    '20.59.01': 'highly_hazardous',
    '20.59.02': 'highly_hazardous',
    '20.59.03': 'highly_hazardous',
    '20.59.04': 'highly_hazardous',
    '20.59.05': 'hazardous',
    '20.59.06': 'hazardous',
    '20.59.07': 'highly_hazardous',
    '20.59.08': 'highly_hazardous',
    '20.59.09': 'highly_hazardous',
    '20.59.10': 'highly_hazardous',
    '20.59.11': 'highly_hazardous',
    '20.59.12': 'hazardous',
    '20.59.15': 'highly_hazardous',
    '20.59.16': 'highly_hazardous',
    '20.59.17': 'highly_hazardous',
    '20.59.18': 'highly_hazardous',
    '20.59.19': 'hazardous',
    '20.59.20': 'highly_hazardous',
    '20.59.99': 'highly_hazardous',
    '20.60.01': 'highly_hazardous',
    '20.60.02': 'hazardous',
    '21.10.01': 'highly_hazardous',
    '21.20.01': 'hazardous',
    '21.20.02': 'hazardous',
    '21.20.03': 'hazardous',
    '21.20.90': 'hazardous',
    '22.11.17': 'highly_hazardous',
    '22.11.18': 'highly_hazardous',
    '22.11.19': 'highly_hazardous',
    '22.12.01': 'hazardous',
    '22.12.02': 'hazardous',
    '22.12.03': 'hazardous',
    '22.12.04': 'hazardous',
    '22.12.05': 'hazardous',
    '22.12.06': 'hazardous',
    '22.12.07': 'hazardous',
    '22.12.08': 'hazardous',
    '22.12.09': 'hazardous',
    '22.12.10': 'hazardous',
    '22.12.11': 'hazardous',
    '22.21.03': 'hazardous',
    '22.21.04': 'hazardous',
    '22.22.43': 'hazardous',
    '22.23.08': 'hazardous',
    '22.24.01': 'hazardous',
    '22.24.02': 'hazardous',
    '22.24.03': 'hazardous',
    '22.24.04': 'hazardous',
    '22.24.05': 'hazardous',
    '22.24.99': 'hazardous',
    '22.25.00': 'hazardous',
    '22.26.01': 'hazardous',
    '22.26.02': 'hazardous',
    '22.26.03': 'hazardous',
    '22.26.04': 'hazardous',
    '22.26.05': 'hazardous',
    '22.26.06': 'hazardous',
    '22.26.99': 'hazardous',
    '23.11.01': 'highly_hazardous',
    '23.12.01': 'highly_hazardous',
    '23.12.02': 'highly_hazardous',
    '23.12.03': 'highly_hazardous',
    '23.12.04': 'highly_hazardous',
    '23.13.01': 'highly_hazardous',
    '23.13.02': 'highly_hazardous',
    '23.14.01': 'highly_hazardous',
    '23.15.01': 'hazardous',
    '23.15.02': 'hazardous',
    '23.15.03': 'hazardous',
    '23.15.04': 'hazardous',
    '23.15.05': 'highly_hazardous',
    '23.15.06': 'hazardous',
    '23.15.07': 'hazardous',
    '23.15.08': 'hazardous',
    '23.15.99': 'hazardous',
    '23.20.16': 'highly_hazardous',
    '23.20.17': 'highly_hazardous',
    '23.20.19': 'highly_hazardous',
    '23.20.20': 'highly_hazardous',
    '23.31.01': 'highly_hazardous',
    '23.32.02': 'highly_hazardous',
    '23.32.03': 'hazardous',
    '23.41.01': 'highly_hazardous',
    '23.41.02': 'highly_hazardous',
    '23.41.03': 'highly_hazardous',
    '23.41.04': 'hazardous',
    '23.42.01': 'highly_hazardous',
    '23.43.01': 'highly_hazardous',
    '23.44.01': 'highly_hazardous',
    '23.45.01': 'highly_hazardous',
    '23.45.99': 'highly_hazardous',
    '23.51.01': 'highly_hazardous',
    '23.52.01': 'highly_hazardous',
    '23.52.02': 'highly_hazardous',
    '23.52.03': 'highly_hazardous',
    '23.61.01': 'hazardous',
    '23.61.02': 'hazardous',
    '23.61.03': 'hazardous',
    '23.62.01': 'hazardous',
    '23.63.01': 'hazardous',
    '23.64.01': 'hazardous',
    '23.65.02': 'hazardous',
    '23.66.00': 'hazardous',
    '23.70.01': 'highly_hazardous',
    '23.70.02': 'hazardous',
    '23.91.01': 'highly_hazardous',
    '23.91.02': 'highly_hazardous',
    '23.99.01': 'highly_hazardous',
    '23.99.02': 'highly_hazardous',
    '23.99.03': 'highly_hazardous',
    '23.99.05': 'highly_hazardous',
    '23.99.07': 'highly_hazardous',
    '23.99.09': 'highly_hazardous',
    '23.99.99': 'highly_hazardous',
    '24.10.01': 'highly_hazardous',
    '24.10.02': 'highly_hazardous',
    '24.10.03': 'highly_hazardous',
    '24.10.05': 'highly_hazardous',
    '24.10.06': 'highly_hazardous',
    '24.10.07': 'highly_hazardous',
    '24.10.08': 'highly_hazardous',
    '24.10.09': 'highly_hazardous',
    '24.10.10': 'highly_hazardous',
    '24.10.12': 'highly_hazardous',
    '24.20.09': 'highly_hazardous',
    '24.20.10': 'hazardous',
    '24.31.01': 'hazardous',
    '24.32.01': 'hazardous',
    '24.33.01': 'hazardous',
    '24.34.01': 'hazardous',
    '24.41.16': 'highly_hazardous',
    '24.41.17': 'highly_hazardous',
    '24.41.18': 'highly_hazardous',
    '24.41.19': 'highly_hazardous',
    '24.42.16': 'hazardous',
    '24.42.17': 'highly_hazardous',
    '24.42.18': 'hazardous',
    '24.42.20': 'highly_hazardous',
    '24.42.21': 'hazardous',
    '24.43.01': 'highly_hazardous',
    '24.43.02': 'highly_hazardous',
    '24.43.04': 'highly_hazardous',
    '24.43.05': 'highly_hazardous',
    '24.43.06': 'highly_hazardous',
    '24.43.07': 'hazardous',
    '24.43.08': 'hazardous',
    '24.44.01': 'highly_hazardous',
    '24.44.03': 'hazardous',
    '24.44.04': 'hazardous',
    '24.45.01': 'highly_hazardous',
    '24.45.02': 'highly_hazardous',
    '24.45.06': 'highly_hazardous',
    '24.46.00': 'highly_hazardous',
    '24.51.13': 'highly_hazardous',
    '24.52.20': 'highly_hazardous',
    '24.53.01': 'highly_hazardous',
    '24.54.02': 'highly_hazardous',
    '24.54.90': 'highly_hazardous',
    '25.11.06': 'hazardous',
    '25.11.07': 'hazardous',
    '25.11.08': 'hazardous',
    '25.12.04': 'hazardous',
    '25.12.05': 'hazardous',
    '25.12.06': 'hazardous',
    '25.21.10': 'hazardous',
    '25.21.12': 'highly_hazardous',
    '25.21.13': 'hazardous',
    '25.21.14': 'highly_hazardous',
    '25.22.01': 'hazardous',
    '25.22.02': 'hazardous',
    '25.30.03': 'highly_hazardous',
    '25.30.04': 'highly_hazardous',
    '25.30.05': 'highly_hazardous',
    '25.40.04': 'hazardous',
    '25.40.05': 'highly_hazardous',
    '25.51.01': 'highly_hazardous',
    '25.51.02': 'highly_hazardous',
    '25.51.09': 'highly_hazardous',
    '25.52.00': 'highly_hazardous',
    '25.53.01': 'hazardous',
    '25.53.02': 'hazardous',
    '25.53.03': 'highly_hazardous',
    '25.61.04': 'hazardous',
    '25.61.05': 'hazardous',
    '25.61.06': 'hazardous',
    '25.61.07': 'hazardous',
    '25.61.08': 'hazardous',
    '25.62.04': 'hazardous',
    '25.63.01': 'hazardous',
    '25.63.02': 'hazardous',
    '25.63.03': 'hazardous',
    '25.63.04': 'hazardous',
    '25.91.01': 'hazardous',
    '25.92.01': 'hazardous',
    '25.92.02': 'hazardous',
    '25.92.03': 'hazardous',
    '25.93.01': 'hazardous',
    '25.93.02': 'hazardous',
    '25.93.03': 'hazardous',
    '25.94.01': 'hazardous',
    '25.94.02': 'hazardous',
    '25.99.01': 'hazardous',
    '25.99.02': 'hazardous',
    '25.99.03': 'hazardous',
    '25.99.04': 'hazardous',
    '25.99.05': 'hazardous',
    '25.99.06': 'hazardous',
    '25.99.08': 'highly_hazardous',
    '25.99.12': 'highly_hazardous',
    '25.99.13': 'hazardous',
    '25.99.14': 'hazardous',
    '25.99.15': 'highly_hazardous',
    '25.99.18': 'hazardous',
    '25.99.21': 'hazardous',
    '25.99.99': 'hazardous',
    '26.11.04': 'hazardous',
    '26.11.05': 'hazardous',
    '26.11.06': 'hazardous',
    '26.11.99': 'hazardous',
    '26.12.01': 'hazardous',
    '26.20.01': 'hazardous',
    '26.30.02': 'hazardous',
    '26.30.03': 'hazardous',
    '26.30.05': 'hazardous',
    '26.30.06': 'hazardous',
    '26.30.08': 'hazardous',
    '26.30.09': 'hazardous',
    '26.30.10': 'hazardous',
    '26.30.99': 'hazardous',
    '26.40.08': 'hazardous',
    '26.40.09': 'hazardous',
    '26.40.10': 'hazardous',
    '26.40.11': 'hazardous',
    '26.40.12': 'hazardous',
    '26.40.99': 'hazardous',
    '26.51.01': 'hazardous',
    '26.51.02': 'hazardous',
    '26.51.03': 'hazardous',
    '26.51.04': 'hazardous',
    '26.51.05': 'hazardous',
    '26.51.06': 'hazardous',
    '26.51.07': 'hazardous',
    '26.51.08': 'hazardous',
    '26.51.09': 'hazardous',
    '26.51.10': 'hazardous',
    '26.51.11': 'hazardous',
    '26.51.12': 'hazardous',
    '26.51.13': 'hazardous',
    '26.51.14': 'hazardous',
    '26.51.15': 'hazardous',
    '26.51.99': 'hazardous',
    '26.52.03': 'hazardous',
    '26.52.04': 'hazardous',
    '26.60.01': 'highly_hazardous',
    '26.70.11': 'hazardous',
    '26.70.12': 'hazardous',
    '26.70.13': 'hazardous',
    '26.70.16': 'hazardous',
    '26.70.19': 'hazardous',
    '26.70.20': 'hazardous',
    '26.70.21': 'hazardous',
    '26.70.22': 'hazardous',
    '26.70.99': 'hazardous',
    '27.11.01': 'hazardous',
    '27.11.03': 'hazardous',
    '27.12.01': 'hazardous',
    '27.12.02': 'hazardous',
    '27.20.01': 'highly_hazardous',
    '27.20.02': 'highly_hazardous',
    '27.20.03': 'highly_hazardous',
    '27.20.04': 'highly_hazardous',
    '27.20.05': 'hazardous',
    '27.31.04': 'hazardous',
    '27.32.03': 'hazardous',
    '27.33.00': 'hazardous',
    '27.40.01': 'hazardous',
    '27.40.02': 'hazardous',
    '27.40.03': 'hazardous',
    '27.40.04': 'hazardous',
    '27.40.05': 'hazardous',
    '27.40.06': 'hazardous',
    '27.40.99': 'hazardous',
    '27.51.02': 'hazardous',
    '27.51.03': 'hazardous',
    '27.51.04': 'hazardous',
    '27.51.05': 'hazardous',
    '27.51.06': 'hazardous',
    '27.51.07': 'hazardous',
    '27.51.08': 'hazardous',
    '27.51.99': 'hazardous',
    '27.52.02': 'hazardous',
    '27.52.05': 'hazardous',
    '27.52.06': 'hazardous',
    '27.90.01': 'hazardous',
    '27.90.03': 'hazardous',
    '27.90.04': 'highly_hazardous',
    '27.90.05': 'hazardous',
    '27.90.06': 'hazardous',
    '27.90.99': 'hazardous',
    '28.11.08': 'hazardous',
    '28.11.09': 'hazardous',
    '28.11.10': 'hazardous',
    '28.12.05': 'hazardous',
    '28.13.01': 'hazardous',
    '28.13.02': 'hazardous',
    '28.13.03': 'hazardous',
    '28.13.04': 'hazardous',
    '28.14.01': 'highly_hazardous',
    '28.14.02': 'hazardous',
    '28.15.01': 'hazardous',
    '28.15.02': 'hazardous',
    '28.15.03': 'hazardous',
    '28.15.04': 'hazardous',
    '28.21.07': 'hazardous',
    '28.21.10': 'hazardous',
    '28.21.99': 'hazardous',
    '28.22.10': 'hazardous',
    '28.22.11': 'hazardous',
    '28.22.12': 'hazardous',
    '28.22.90': 'hazardous',
    '28.23.00': 'hazardous',
    '28.23.90': 'hazardous',
    '28.24.01': 'hazardous',
    '28.25.01': 'hazardous',
    '28.25.02': 'hazardous',
    '28.25.03': 'hazardous',
    '28.25.04': 'hazardous',
    '28.29.05': 'hazardous',
    '28.29.07': 'hazardous',
    '28.29.08': 'hazardous',
    '28.29.10': 'hazardous',
    '28.29.18': 'hazardous',
    '28.29.90': 'hazardous',
    '28.30.08': 'hazardous',
    '28.30.09': 'hazardous',
    '28.30.10': 'hazardous',
    '28.30.11': 'hazardous',
    '28.30.12': 'hazardous',
    '28.30.13': 'hazardous',
    '28.30.14': 'hazardous',
    '28.30.15': 'hazardous',
    '28.30.16': 'hazardous',
    '28.30.90': 'hazardous',
    '28.41.01': 'hazardous',
    '28.41.03': 'hazardous',
    '28.41.07': 'hazardous',
    '28.41.90': 'hazardous',
    '28.42.01': 'hazardous',
    '28.42.02': 'hazardous',
    '28.42.03': 'hazardous',
    '28.42.99': 'hazardous',
    '28.91.01': 'hazardous',
    '28.91.02': 'hazardous',
    '28.92.01': 'hazardous',
    '28.92.02': 'hazardous',
    '28.92.03': 'hazardous',
    '28.92.05': 'hazardous',
    '28.92.06': 'hazardous',
    '28.92.08': 'hazardous',
    '28.92.09': 'hazardous',
    '28.92.10': 'hazardous',
    '28.92.11': 'hazardous',
    '28.93.02': 'hazardous',
    '28.93.03': 'hazardous',
    '28.93.04': 'hazardous',
    '28.93.06': 'hazardous',
    '28.93.07': 'hazardous',
    '28.93.08': 'hazardous',
    '28.93.09': 'hazardous',
    '28.93.10': 'hazardous',
    '28.93.99': 'hazardous',
    '28.94.01': 'hazardous',
    '28.94.02': 'hazardous',
    '28.94.03': 'hazardous',
    '28.94.04': 'hazardous',
    '28.94.05': 'hazardous',
    '28.94.06': 'hazardous',
    '28.94.07': 'hazardous',
    '28.94.08': 'hazardous',
    '28.94.09': 'hazardous',
    '28.95.01': 'hazardous',
    '28.96.01': 'hazardous',
    '28.97.00': 'hazardous',
    '28.99.01': 'hazardous',
    '28.99.02': 'hazardous',
    '28.99.04': 'hazardous',
    '28.99.06': 'hazardous',
    '28.99.07': 'hazardous',
    '28.99.08': 'hazardous',
    '28.99.09': 'hazardous',
    '28.99.10': 'hazardous',
    '28.99.11': 'hazardous',
    '28.99.12': 'highly_hazardous',
    '28.99.99': 'hazardous',
    '29.10.01': 'hazardous',
    '29.10.02': 'hazardous',
    '29.10.03': 'hazardous',
    '29.10.04': 'hazardous',
    '29.10.05': 'hazardous',
    '29.10.07': 'hazardous',
    '29.10.08': 'hazardous',
    '29.20.01': 'hazardous',
    '29.20.02': 'hazardous',
    '29.20.03': 'hazardous',
    '29.20.04': 'hazardous',
    '29.20.05': 'hazardous',
    '29.20.06': 'hazardous',
    '29.31.04': 'hazardous',
    '29.31.05': 'hazardous',
    '29.31.90': 'hazardous',
    '29.32.20': 'hazardous',
    '29.32.21': 'hazardous',
    '29.32.22': 'hazardous',
    '29.32.23': 'hazardous',
    '29.32.24': 'hazardous',
    '30.11.01': 'highly_hazardous',
    '30.11.02': 'highly_hazardous',
    '30.11.04': 'highly_hazardous',
    '30.11.05': 'highly_hazardous',
    '30.11.06': 'highly_hazardous',
    '30.11.07': 'highly_hazardous',
    '30.11.08': 'highly_hazardous',
    '30.12.01': 'hazardous',
    '30.12.03': 'hazardous',
    '30.12.04': 'highly_hazardous',
    '30.13.00': 'highly_hazardous',
    '30.20.01': 'hazardous',
    '30.20.02': 'hazardous',
    '30.20.03': 'hazardous',
    '30.20.04': 'hazardous',
    '30.20.05': 'hazardous',
    '30.31.01': 'hazardous',
    '30.31.02': 'hazardous',
    '30.31.03': 'hazardous',
    '30.31.04': 'hazardous',
    '30.31.05': 'hazardous',
    '30.31.06': 'highly_hazardous',
    '30.31.07': 'hazardous',
    '30.32.00': 'highly_hazardous',
    '30.40.01': 'highly_hazardous',
    '30.91.01': 'hazardous',
    '30.91.02': 'hazardous',
    '30.91.03': 'hazardous',
    '30.92.01': 'hazardous',
    '30.92.02': 'hazardous',
    '30.92.03': 'hazardous',
    '30.92.04': 'hazardous',
    '30.92.05': 'hazardous',
    '30.99.01': 'hazardous',
    '30.99.02': 'low_risk',
    '30.99.99': 'hazardous',
    '31.00.01': 'hazardous',
    '31.00.02': 'hazardous',
    '31.00.03': 'hazardous',
    '31.00.04': 'hazardous',
    '31.00.05': 'hazardous',
    '31.00.06': 'highly_hazardous',
    '31.00.07': 'hazardous',
    '31.00.08': 'hazardous',
    '31.00.09': 'hazardous',
    '31.00.90': 'hazardous',
    '32.11.01': 'hazardous',
    '32.12.01': 'hazardous',
    '32.12.04': 'hazardous',
    '32.12.90': 'hazardous',
    '32.13.01': 'hazardous',
    '32.20.21': 'hazardous',
    '32.20.23': 'hazardous',
    '32.20.24': 'hazardous',
    '32.20.25': 'low_risk',
    '32.20.26': 'low_risk',
    '32.20.27': 'low_risk',
    '32.20.28': 'low_risk',
    '32.20.90': 'low_risk',
    '32.20.99': 'low_risk',
    '32.30.17': 'hazardous',
    '32.30.18': 'hazardous',
    '32.30.19': 'hazardous',
    '32.30.20': 'hazardous',
    '32.30.21': 'hazardous',
    '32.40.02': 'hazardous',
    '32.40.03': 'hazardous',
    '32.40.04': 'low_risk',
    '32.40.05': 'hazardous',
    '32.40.06': 'hazardous',
    '32.40.09': 'hazardous',
    '32.40.10': 'hazardous',
    '32.40.99': 'hazardous',
    '32.50.02': 'hazardous',
    '32.50.03': 'highly_hazardous',
    '32.50.04': 'hazardous',
    '32.50.05': 'hazardous',
    '32.50.06': 'hazardous',
    '32.50.07': 'hazardous',
    '32.50.14': 'hazardous',
    '32.50.15': 'hazardous',
    '32.50.90': 'hazardous',
    '32.91.01': 'hazardous',
    '32.91.02': 'hazardous',
    '32.91.03': 'hazardous',
    '32.91.99': 'hazardous',
    '32.99.01': 'hazardous',
    '32.99.02': 'hazardous',
    '32.99.03': 'hazardous',
    '32.99.04': 'hazardous',
    '32.99.05': 'hazardous',
    '32.99.06': 'low_risk',
    '32.99.07': 'hazardous',
    '32.99.08': 'low_risk',
    '32.99.09': 'hazardous',
    '32.99.10': 'hazardous',
    '32.99.11': 'hazardous',
    '32.99.13': 'hazardous',
    '32.99.15': 'hazardous',
    '32.99.16': 'hazardous',
    '32.99.17': 'hazardous',
    '32.99.18': 'hazardous',
    '32.99.19': 'hazardous',
    '32.99.99': 'hazardous',
    '33.11.01': 'hazardous',
    '33.11.02': 'hazardous',
    '33.11.03': 'hazardous',
    '33.11.04': 'hazardous',
    '33.11.10': 'hazardous',
    '33.11.11': 'highly_hazardous',
    '33.11.99': 'hazardous',
    '33.12.02': 'hazardous',
    '33.12.03': 'hazardous',
    '33.12.04': 'hazardous',
    '33.12.05': 'hazardous',
    '33.12.06': 'hazardous',
    '33.12.07': 'low_risk',
    '33.12.08': 'hazardous',
    '33.12.09': 'hazardous',
    '33.12.10': 'hazardous',
    '33.12.11': 'hazardous',
    '33.12.12': 'hazardous',
    '33.12.13': 'hazardous',
    '33.12.14': 'hazardous',
    '33.12.15': 'hazardous',
    '33.12.16': 'hazardous',
    '33.12.17': 'hazardous',
    '33.12.18': 'low_risk',
    '33.12.19': 'hazardous',
    '33.12.21': 'low_risk',
    '33.12.27': 'hazardous',
    '33.12.28': 'hazardous',
    '33.12.29': 'hazardous',
    '33.12.30': 'hazardous',
    '33.12.99': 'hazardous',
    '33.13.01': 'low_risk',
    '33.13.02': 'highly_hazardous',
    '33.13.03': 'hazardous',
    '33.13.05': 'hazardous',
    '33.13.90': 'hazardous',
    '33.14.01': 'hazardous',
    '33.14.02': 'hazardous',
    '33.14.90': 'hazardous',
    '33.15.00': 'highly_hazardous',
    '33.16.01': 'hazardous',
    '33.17.01': 'hazardous',
    '33.17.99': 'low_risk',
    '33.18.01': 'highly_hazardous',
    '33.18.03': 'highly_hazardous',
    '33.19.01': 'low_risk',
    '33.19.02': 'low_risk',
    '33.19.99': 'low_risk',
    '33.20.36': 'hazardous',
    '33.20.45': 'hazardous',
    '33.20.46': 'hazardous',
    '33.20.51': 'hazardous',
    '33.20.52': 'hazardous',
    '33.20.53': 'hazardous',
    '33.20.90': 'hazardous',
    '35.11.00': 'highly_hazardous',
    '35.12.00': 'highly_hazardous',
    '35.13.00': 'highly_hazardous',
    '35.14.02': 'hazardous',
    '35.14.06': 'highly_hazardous',
    '35.15.01': 'hazardous',
    '35.15.02': 'low_risk',
    '35.16.00': 'highly_hazardous',
    '35.21.01': 'highly_hazardous',
    '35.21.02': 'highly_hazardous',
    '35.22.01': 'highly_hazardous',
    '35.22.02': 'low_risk',
    '35.23.01': 'low_risk',
    '35.24.00': 'highly_hazardous',
    '35.30.21': 'highly_hazardous',
    '35.30.22': 'hazardous',
    '35.40.00': 'low_risk',
    '36.00.02': 'highly_hazardous',
    '36.00.03': 'low_risk',
    '37.00.01': 'highly_hazardous',
    '38.11.01': 'hazardous',
    '38.11.02': 'hazardous',
    '38.11.03': 'hazardous',
    '38.12.01': 'highly_hazardous',
    '38.21.02': 'highly_hazardous',
    '38.21.03': 'highly_hazardous',
    '38.21.04': 'highly_hazardous',
    '38.21.05': 'highly_hazardous',
    '38.22.00': 'highly_hazardous',
    '38.23.00': 'highly_hazardous',
    '38.31.00': 'highly_hazardous',
    '38.32.03': 'hazardous',
    '38.32.04': 'highly_hazardous',
    '38.32.05': 'highly_hazardous',
    '38.33.00': 'highly_hazardous',
    '39.00.01': 'highly_hazardous',
    '41.00.01': 'highly_hazardous',
    '41.00.02': 'highly_hazardous',
    '41.00.03': 'highly_hazardous',
    '41.00.04': 'highly_hazardous',
    '41.00.05': 'highly_hazardous',
    '42.11.01': 'highly_hazardous',
    '42.11.02': 'highly_hazardous',
    '42.11.03': 'highly_hazardous',
    '42.12.01': 'highly_hazardous',
    '42.13.01': 'highly_hazardous',
    '42.13.02': 'highly_hazardous',
    '42.21.01': 'highly_hazardous',
    '42.21.02': 'highly_hazardous',
    '42.21.03': 'highly_hazardous',
    '42.21.05': 'highly_hazardous',
    '42.22.01': 'highly_hazardous',
    '42.22.02': 'highly_hazardous',
    '42.22.04': 'highly_hazardous',
    '42.22.05': 'highly_hazardous',
    '42.22.06': 'highly_hazardous',
    '42.22.07': 'highly_hazardous',
    '42.91.01': 'highly_hazardous',
    '42.91.02': 'highly_hazardous',
    '42.91.03': 'highly_hazardous',
    '42.91.04': 'highly_hazardous',
    '42.99.01': 'highly_hazardous',
    '42.99.02': 'highly_hazardous',
    '42.99.04': 'highly_hazardous',
    '42.99.05': 'hazardous',
    '42.99.99': 'highly_hazardous',
    '43.11.01': 'highly_hazardous',
    '43.13.01': 'highly_hazardous',
    '43.21.01': 'highly_hazardous',
    '43.21.03': 'highly_hazardous',
    '43.22.03': 'highly_hazardous',
    '43.22.05': 'highly_hazardous',
    '43.23.01': 'highly_hazardous',
    '43.23.02': 'highly_hazardous',
    '43.24.01': 'highly_hazardous',
    '43.24.03': 'highly_hazardous',
    '43.24.99': 'highly_hazardous',
    '43.31.01': 'highly_hazardous',
    '43.32.01': 'hazardous',
    '43.32.02': 'hazardous',
    '43.32.03': 'hazardous',
    '43.33.01': 'highly_hazardous',
    '43.33.99': 'hazardous',
    '43.34.01': 'highly_hazardous',
    '43.34.02': 'highly_hazardous',
    '43.34.03': 'highly_hazardous',
    '43.35.00': 'hazardous',
    '43.41.00': 'highly_hazardous',
    '43.42.01': 'highly_hazardous',
    '43.42.02': 'highly_hazardous',
    '43.42.03': 'highly_hazardous',
    '43.42.99': 'hazardous',
    '43.50.01': 'highly_hazardous',
    '43.50.02': 'highly_hazardous',
    '43.50.03': 'highly_hazardous',
    '43.50.04': 'hazardous',
    '43.50.05': 'highly_hazardous',
    '43.50.06': 'hazardous',
    '43.60.00': 'low_risk',
    '43.91.00': 'highly_hazardous',
    '43.99.04': 'low_risk',
    '43.99.05': 'highly_hazardous',
    '43.99.07': 'highly_hazardous',
    '43.99.13': 'highly_hazardous',
    '43.99.99': 'hazardous',
    '46.11.01': 'low_risk',
    '46.11.02': 'low_risk',
    '46.11.90': 'low_risk',
    '46.12.01': 'low_risk',
    '46.12.02': 'low_risk',
    '46.12.03': 'low_risk',
    '46.13.01': 'low_risk',
    '46.13.02': 'low_risk',
    '46.14.01': 'low_risk',
    '46.14.02': 'low_risk',
    '46.14.03': 'low_risk',
    '46.15.01': 'low_risk',
    '46.15.02': 'low_risk',
    '46.15.03': 'low_risk',
    '46.15.90': 'low_risk',
    '46.16.01': 'low_risk',
    '46.16.02': 'low_risk',
    '46.16.03': 'low_risk',
    '46.16.04': 'low_risk',
    '46.17.01': 'low_risk',
    '46.17.02': 'low_risk',
    '46.17.03': 'low_risk',
    '46.17.04': 'low_risk',
    '46.18.01': 'low_risk',
    '46.18.02': 'low_risk',
    '46.18.03': 'low_risk',
    '46.18.04': 'low_risk',
    '46.18.05': 'low_risk',
    '46.18.06': 'low_risk',
    '46.18.07': 'low_risk',
    '46.18.08': 'low_risk',
    '46.18.09': 'low_risk',
    '46.18.99': 'low_risk',
    '46.19.01': 'low_risk',
    '46.21.01': 'low_risk',
    '46.21.02': 'low_risk',
    '46.21.03': 'low_risk',
    '46.21.06': 'hazardous',
    '46.21.07': 'low_risk',
    '46.21.08': 'low_risk',
    '46.21.99': 'low_risk',
    '46.22.01': 'low_risk',
    '46.23.01': 'hazardous',
    '46.23.02': 'hazardous',
    '46.24.01': 'low_risk',
    '46.24.02': 'low_risk',
    '46.31.01': 'low_risk',
    '46.31.02': 'low_risk',
    '46.31.03': 'low_risk',
    '46.31.04': 'low_risk',
    '46.31.05': 'low_risk',
    '46.31.06': 'low_risk',
    '46.31.08': 'low_risk',
    '46.31.09': 'low_risk',
    '46.31.10': 'low_risk',
    '46.31.11': 'low_risk',
    '46.31.12': 'low_risk',
    '46.31.90': 'low_risk',
    '46.32.01': 'hazardous',
    '46.32.02': 'hazardous',
    '46.32.03': 'hazardous',
    '46.32.04': 'hazardous',
    '46.32.05': 'hazardous',
    '46.33.01': 'hazardous',
    '46.33.02': 'low_risk',
    '46.33.03': 'low_risk',
    '46.34.01': 'low_risk',
    '46.34.02': 'low_risk',
    '46.34.03': 'low_risk',
    '46.35.01': 'low_risk',
    '46.36.01': 'low_risk',
    '46.36.02': 'low_risk',
    '46.36.03': 'low_risk',
    '46.37.01': 'low_risk',
    '46.37.02': 'low_risk',
    '46.37.03': 'low_risk',
    '46.38.02': 'low_risk',
    '46.38.03': 'low_risk',
    '46.38.04': 'low_risk',
    '46.38.05': 'low_risk',
    '46.38.99': 'low_risk',
    '46.39.03': 'low_risk',
    '46.41.01': 'low_risk',
    '46.41.02': 'low_risk',
    '46.41.03': 'low_risk',
    '46.41.04': 'low_risk',
    '46.41.90': 'low_risk',
    '46.42.01': 'low_risk',
    '46.42.02': 'low_risk',
    '46.42.03': 'low_risk',
    '46.42.04': 'low_risk',
    '46.42.05': 'low_risk',
    '46.42.06': 'low_risk',
    '46.42.07': 'low_risk',
    '46.42.08': 'low_risk',
    '46.43.01': 'low_risk',
    '46.43.08': 'low_risk',
    '46.43.09': 'low_risk',
    '46.43.10': 'low_risk',
    '46.43.11': 'low_risk',
    '46.43.12': 'low_risk',
    '46.43.90': 'low_risk',
    '46.44.01': 'low_risk',
    '46.44.02': 'low_risk',
    '46.44.04': 'low_risk',
    '46.45.01': 'low_risk',
    '46.45.02': 'low_risk',
    '46.46.01': 'low_risk',
    '46.46.02': 'low_risk',
    '46.46.03': 'low_risk',
    '46.46.04': 'low_risk',
    '46.47.01': 'low_risk',
    '46.47.02': 'low_risk',
    '46.47.03': 'low_risk',
    '46.47.04': 'low_risk',
    '46.48.01': 'low_risk',
    '46.48.02': 'low_risk',
    '46.49.01': 'low_risk',
    '46.49.02': 'low_risk',
    '46.49.03': 'low_risk',
    '46.49.04': 'low_risk',
    '46.49.05': 'low_risk',
    '46.49.06': 'low_risk',
    '46.49.07': 'low_risk',
    '46.49.08': 'low_risk',
    '46.49.09': 'low_risk',
    '46.49.11': 'low_risk',
    '46.49.12': 'low_risk',
    '46.49.13': 'low_risk',
    '46.49.17': 'low_risk',
    '46.49.22': 'low_risk',
    '46.49.24': 'low_risk',
    '46.49.25': 'low_risk',
    '46.49.26': 'low_risk',
    '46.49.99': 'low_risk',
    '46.50.01': 'low_risk',
    '46.50.02': 'low_risk',
    '46.50.03': 'low_risk',
    '46.50.90': 'low_risk',
    '46.61.02': 'low_risk',
    '46.61.03': 'low_risk',
    '46.62.01': 'low_risk',
    '46.62.02': 'low_risk',
    '46.62.04': 'low_risk',
    '46.62.90': 'low_risk',
    '46.63.01': 'low_risk',
    '46.63.02': 'low_risk',
    '46.64.03': 'low_risk',
    '46.64.04': 'low_risk',
    '46.64.05': 'low_risk',
    '46.64.06': 'low_risk',
    '46.64.07': 'low_risk',
    '46.64.08': 'low_risk',
    '46.64.09': 'low_risk',
    '46.64.10': 'hazardous',
    '46.64.11': 'low_risk',
    '46.64.12': 'low_risk',
    '46.64.13': 'low_risk',
    '46.64.14': 'low_risk',
    '46.64.15': 'low_risk',
    '46.64.16': 'low_risk',
    '46.64.99': 'low_risk',
    '46.71.04': 'low_risk',
    '46.71.90': 'low_risk',
    '46.72.12': 'low_risk',
    '46.72.13': 'low_risk',
    '46.72.14': 'low_risk',
    '46.72.15': 'low_risk',
    '46.73.24': 'low_risk',
    '46.73.25': 'low_risk',
    '46.81.01': 'highly_hazardous',
    '46.81.02': 'highly_hazardous',
    '46.81.03': 'highly_hazardous',
    '46.82.01': 'hazardous',
    '46.82.02': 'low_risk',
    '46.82.03': 'hazardous',
    '46.82.04': 'hazardous',
    '46.82.05': 'hazardous',
    '46.82.06': 'hazardous',
    '46.82.07': 'hazardous',
    '46.82.08': 'hazardous',
    '46.82.09': 'hazardous',
    '46.82.10': 'highly_hazardous',
    '46.83.01': 'low_risk',
    '46.83.02': 'hazardous',
    '46.83.03': 'low_risk',
    '46.83.04': 'hazardous',
    '46.83.05': 'low_risk',
    '46.83.06': 'hazardous',
    '46.83.07': 'hazardous',
    '46.83.08': 'low_risk',
    '46.83.09': 'low_risk',
    '46.83.10': 'low_risk',
    '46.83.11': 'low_risk',
    '46.83.12': 'hazardous',
    '46.83.13': 'low_risk',
    '46.83.14': 'low_risk',
    '46.83.15': 'low_risk',
    '46.83.16': 'hazardous',
    '46.83.17': 'hazardous',
    '46.83.18': 'low_risk',
    '46.83.19': 'low_risk',
    '46.83.20': 'low_risk',
    '46.83.21': 'hazardous',
    '46.83.22': 'hazardous',
    '46.83.99': 'hazardous',
    '46.84.01': 'low_risk',
    '46.84.02': 'low_risk',
    '46.84.03': 'low_risk',
    '46.84.04': 'low_risk',
    '46.84.05': 'low_risk',
    '46.84.06': 'low_risk',
    '46.85.01': 'highly_hazardous',
    '46.85.02': 'low_risk',
    '46.85.03': 'hazardous',
    '46.85.04': 'highly_hazardous',
    '46.85.05': 'low_risk',
    '46.86.01': 'low_risk',
    '46.86.02': 'low_risk',
    '46.86.03': 'low_risk',
    '46.86.04': 'low_risk',
    '46.86.05': 'low_risk',
    '46.86.99': 'low_risk',
    '46.87.01': 'hazardous',
    '46.87.02': 'hazardous',
    '46.89.00': 'low_risk',
    '46.90.01': 'low_risk',
    '46.90.04': 'low_risk',
    '47.11.01': 'low_risk',
    '47.11.02': 'low_risk',
    '47.11.03': 'low_risk',
    '47.11.04': 'low_risk',
    '47.11.05': 'low_risk',
    '47.11.06': 'low_risk',
    '47.11.99': 'low_risk',
    '47.12.01': 'low_risk',
    '47.12.02': 'low_risk',
    '47.12.03': 'low_risk',
    '47.21.01': 'low_risk',
    '47.21.02': 'low_risk',
    '47.21.03': 'low_risk',
    '47.21.04': 'low_risk',
    '47.21.05': 'low_risk',
    '47.21.06': 'low_risk',
    '47.22.02': 'low_risk',
    '47.22.05': 'hazardous',
    '47.22.06': 'hazardous',
    '47.22.07': 'low_risk',
    '47.23.01': 'low_risk',
    '47.23.02': 'low_risk',
    '47.24.01': 'low_risk',
    '47.24.02': 'low_risk',
    '47.24.03': 'low_risk',
    '47.24.04': 'low_risk',
    '47.25.01': 'low_risk',
    '47.25.03': 'low_risk',
    '47.26.01': 'low_risk',
    '47.26.02': 'low_risk',
    '47.27.01': 'low_risk',
    '47.27.02': 'low_risk',
    '47.27.03': 'low_risk',
    '47.27.04': 'low_risk',
    '47.27.05': 'low_risk',
    '47.27.06': 'low_risk',
    '47.27.07': 'low_risk',
    '47.27.08': 'low_risk',
    '47.27.09': 'low_risk',
    '47.27.10': 'low_risk',
    '47.27.99': 'low_risk',
    '47.30.01': 'highly_hazardous',
    '47.30.02': 'low_risk',
    '47.40.01': 'low_risk',
    '47.40.02': 'low_risk',
    '47.40.03': 'low_risk',
    '47.51.02': 'low_risk',
    '47.51.03': 'low_risk',
    '47.51.04': 'low_risk',
    '47.51.05': 'low_risk',
    '47.51.06': 'low_risk',
    '47.51.07': 'low_risk',
    '47.51.90': 'low_risk',
    '47.52.01': 'hazardous',
    '47.52.02': 'low_risk',
    '47.52.03': 'hazardous',
    '47.52.04': 'low_risk',
    '47.52.05': 'low_risk',
    '47.52.06': 'low_risk',
    '47.52.09': 'low_risk',
    '47.52.10': 'hazardous',
    '47.52.11': 'low_risk',
    '47.52.13': 'hazardous',
    '47.52.15': 'low_risk',
    '47.52.16': 'low_risk',
    '47.52.17': 'low_risk',
    '47.52.18': 'hazardous',
    '47.52.19': 'low_risk',
    '47.52.20': 'low_risk',
    '47.52.21': 'low_risk',
    '47.52.22': 'low_risk',
    '47.52.23': 'low_risk',
    '47.52.24': 'low_risk',
    '47.52.25': 'low_risk',
    '47.52.99': 'low_risk',
    '47.53.01': 'low_risk',
    '47.53.02': 'low_risk',
    '47.53.03': 'low_risk',
    '47.53.04': 'low_risk',
    '47.54.01': 'low_risk',
    '47.54.03': 'low_risk',
    '47.54.99': 'low_risk',
    '47.55.01': 'low_risk',
    '47.55.02': 'low_risk',
    '47.55.03': 'low_risk',
    '47.55.04': 'low_risk',
    '47.55.05': 'low_risk',
    '47.55.06': 'low_risk',
    '47.55.07': 'low_risk',
    '47.55.08': 'low_risk',
    '47.55.09': 'low_risk',
    '47.55.10': 'low_risk',
    '47.55.11': 'low_risk',
    '47.55.12': 'low_risk',
    '47.55.13': 'low_risk',
    '47.55.99': 'low_risk',
    '47.61.00': 'low_risk',
    '47.62.01': 'low_risk',
    '47.62.03': 'low_risk',
    '47.63.02': 'low_risk',
    '47.63.03': 'low_risk',
    '47.63.04': 'low_risk',
    '47.63.05': 'low_risk',
    '47.63.07': 'low_risk',
    '47.63.08': 'hazardous',
    '47.63.90': 'low_risk',
    '47.64.08': 'low_risk',
    '47.64.09': 'low_risk',
    '47.69.01': 'low_risk',
    '47.69.02': 'low_risk',
    '47.69.03': 'low_risk',
    '47.69.99': 'low_risk',
    '47.71.01': 'low_risk',
    '47.71.02': 'low_risk',
    '47.71.03': 'low_risk',
    '47.71.04': 'low_risk',
    '47.71.05': 'low_risk',
    '47.71.07': 'low_risk',
    '47.71.08': 'low_risk',
    '47.71.09': 'low_risk',
    '47.71.11': 'low_risk',
    '47.71.12': 'low_risk',
    '47.71.13': 'low_risk',
    '47.71.99': 'low_risk',
    '47.72.01': 'low_risk',
    '47.72.02': 'low_risk',
    '47.72.05': 'low_risk',
    '47.72.06': 'low_risk',
    '47.72.90': 'low_risk',
    '47.73.01': 'low_risk',
    '47.73.02': 'low_risk',
    '47.74.01': 'low_risk',
    '47.74.02': 'low_risk',
    '47.75.01': 'low_risk',
    '47.75.02': 'low_risk',
    '47.76.01': 'low_risk',
    '47.76.02': 'low_risk',
    '47.76.03': 'hazardous',
    '47.76.04': 'hazardous',
    '47.76.05': 'hazardous',
    '47.76.06': 'low_risk',
    '47.76.07': 'hazardous',
    '47.77.01': 'low_risk',
    '47.77.02': 'low_risk',
    '47.77.03': 'low_risk',
    '47.77.05': 'low_risk',
    '47.78.02': 'low_risk',
    '47.78.04': 'low_risk',
    '47.78.07': 'low_risk',
    '47.78.08': 'low_risk',
    '47.78.09': 'hazardous',
    '47.78.10': 'highly_hazardous',
    '47.78.15': 'low_risk',
    '47.78.16': 'low_risk',
    '47.78.22': 'low_risk',
    '47.78.26': 'low_risk',
    '47.78.30': 'low_risk',
    '47.78.31': 'hazardous',
    '47.78.99': 'low_risk',
    '47.79.01': 'low_risk',
    '47.79.03': 'low_risk',
    '47.79.04': 'low_risk',
    '47.79.06': 'low_risk',
    '47.79.90': 'low_risk',
    '47.81.14': 'low_risk',
    '47.81.90': 'low_risk',
    '47.82.04': 'low_risk',
    '47.82.05': 'low_risk',
    '47.82.06': 'low_risk',
    '47.82.07': 'low_risk',
    '47.82.08': 'low_risk',
    '47.82.90': 'low_risk',
    '47.83.01': 'low_risk',
    '47.83.02': 'low_risk',
    '47.91.14': 'low_risk',
    '47.91.15': 'low_risk',
    '47.92.00': 'low_risk',
    '49.11.00': 'low_risk',
    '49.12.00': 'low_risk',
    '49.20.01': 'hazardous',
    '49.31.04': 'low_risk',
    '49.31.05': 'low_risk',
    '49.31.06': 'low_risk',
    '49.31.07': 'low_risk',
    '49.31.08': 'low_risk',
    '49.31.09': 'low_risk',
    '49.31.10': 'low_risk',
    '49.31.90': 'low_risk',
    '49.32.04': 'low_risk',
    '49.33.01': 'low_risk',
    '49.33.02': 'low_risk',
    '49.34.00': 'hazardous',
    '49.39.00': 'low_risk',
    '49.41.01': 'hazardous',
    '49.41.02': 'hazardous',
    '49.41.03': 'hazardous',
    '49.41.05': 'hazardous',
    '49.41.06': 'low_risk',
    '49.41.08': 'low_risk',
    '49.41.09': 'highly_hazardous',
    '49.41.10': 'highly_hazardous',
    '49.41.11': 'highly_hazardous',
    '49.41.90': 'hazardous',
    '49.42.01': 'hazardous',
    '49.50.01': 'highly_hazardous',
    '49.50.03': 'highly_hazardous',
    '49.50.04': 'highly_hazardous',
    '49.50.90': 'highly_hazardous',
    '50.10.12': 'hazardous',
    '50.10.13': 'hazardous',
    '50.10.14': 'low_risk',
    '50.10.15': 'hazardous',
    '50.10.16': 'hazardous',
    '50.10.90': 'hazardous',
    '50.20.17': 'highly_hazardous',
    '50.20.18': 'hazardous',
    '50.20.19': 'hazardous',
    '50.20.20': 'hazardous',
    '50.20.21': 'hazardous',
    '50.20.22': 'hazardous',
    '50.20.23': 'hazardous',
    '50.20.24': 'highly_hazardous',
    '50.20.25': 'highly_hazardous',
    '50.20.26': 'hazardous',
    '50.20.27': 'hazardous',
    '50.20.28': 'hazardous',
    '50.20.29': 'hazardous',
    '50.20.30': 'highly_hazardous',
    '50.20.90': 'hazardous',
    '50.20.91': 'hazardous',
    '50.30.08': 'hazardous',
    '50.30.09': 'hazardous',
    '50.40.05': 'hazardous',
    '50.40.07': 'hazardous',
    '50.40.08': 'hazardous',
    '51.10.01': 'hazardous',
    '51.10.02': 'hazardous',
    '51.10.03': 'hazardous',
    '51.21.17': 'hazardous',
    '51.22.02': 'highly_hazardous',
    '52.10.02': 'hazardous',
    '52.10.03': 'hazardous',
    '52.10.04': 'highly_hazardous',
    '52.10.05': 'hazardous',
    '52.10.90': 'hazardous',
    '52.21.04': 'hazardous',
    '52.21.05': 'low_risk',
    '52.21.06': 'low_risk',
    '52.21.07': 'low_risk',
    '52.21.08': 'low_risk',
    '52.21.09': 'low_risk',
    '52.21.10': 'low_risk',
    '52.21.12': 'highly_hazardous',
    '52.21.13': 'low_risk',
    '52.21.90': 'low_risk',
    '52.22.06': 'hazardous',
    '52.22.07': 'low_risk',
    '52.22.08': 'hazardous',
    '52.22.10': 'hazardous',
    '52.23.03': 'hazardous',
    '52.23.04': 'low_risk',
    '52.23.06': 'hazardous',
    '52.23.07': 'highly_hazardous',
    '52.23.90': 'highly_hazardous',
    '52.24.08': 'hazardous',
    '52.24.09': 'hazardous',
    '52.24.10': 'hazardous',
    '52.24.11': 'hazardous',
    '52.24.90': 'hazardous',
    '52.25.01': 'low_risk',
    '52.25.99': 'hazardous',
    '52.26.01': 'low_risk',
    '52.26.02': 'low_risk',
    '52.26.03': 'low_risk',
    '52.26.04': 'low_risk',
    '52.26.05': 'low_risk',
    '52.26.06': 'low_risk',
    '52.26.07': 'low_risk',
    '52.26.08': 'low_risk',
    '52.26.09': 'low_risk',
    '52.26.99': 'low_risk',
    '52.31.01': 'low_risk',
    '52.31.02': 'low_risk',
    '52.31.03': 'low_risk',
    '52.31.04': 'low_risk',
    '52.32.00': 'low_risk',
    '53.10.01': 'low_risk',
    '53.20.08': 'hazardous',
    '53.20.10': 'hazardous',
    '53.30.00': 'low_risk',
    '55.10.02': 'low_risk',
    '55.10.05': 'low_risk',
    '55.20.01': 'low_risk',
    '55.20.03': 'low_risk',
    '55.20.04': 'low_risk',
    '55.30.36': 'low_risk',
    '55.40.00': 'low_risk',
    '55.90.01': 'low_risk',
    '55.90.02': 'low_risk',
    '55.90.04': 'low_risk',
    '55.90.90': 'low_risk',
    '56.11.01': 'low_risk',
    '56.11.02': 'low_risk',
    '56.11.03': 'low_risk',
    '56.11.04': 'low_risk',
    '56.11.05': 'low_risk',
    '56.11.06': 'low_risk',
    '56.11.07': 'low_risk',
    '56.11.08': 'low_risk',
    '56.11.09': 'low_risk',
    '56.11.10': 'low_risk',
    '56.11.11': 'low_risk',
    '56.11.12': 'low_risk',
    '56.11.13': 'low_risk',
    '56.11.90': 'low_risk',
    '56.12.00': 'low_risk',
    '56.21.01': 'low_risk',
    '56.22.01': 'low_risk',
    '56.22.02': 'low_risk',
    '56.22.90': 'low_risk',
    '56.30.02': 'low_risk',
    '56.30.03': 'low_risk',
    '56.30.04': 'hazardous',
    '56.30.05': 'hazardous',
    '56.30.08': 'low_risk',
    '56.30.90': 'low_risk',
    '56.40.00': 'low_risk',
    '58.11.01': 'low_risk',
    '58.11.03': 'low_risk',
    '58.11.04': 'low_risk',
    '58.12.00': 'low_risk',
    '58.13.02': 'low_risk',
    '58.13.03': 'low_risk',
    '58.13.90': 'low_risk',
    '58.19.04': 'low_risk',
    '58.19.99': 'low_risk',
    '58.21.01': 'low_risk',
    '58.29.01': 'low_risk',
    '59.11.04': 'hazardous',
    '59.11.05': 'hazardous',
    '59.12.01': 'low_risk',
    '59.13.02': 'low_risk',
    '59.14.02': 'low_risk',
    '59.20.01': 'low_risk',
    '59.20.02': 'hazardous',
    '59.20.03': 'low_risk',
    '59.20.06': 'low_risk',
    '60.10.09': 'low_risk',
    '60.20.00': 'low_risk',
    '60.31.00': 'low_risk',
    '61.10.03': 'low_risk',
    '61.10.04': 'low_risk',
    '61.10.05': 'hazardous',
    '61.10.15': 'low_risk',
    '61.10.17': 'low_risk',
    '61.20.04': 'low_risk',
    '61.90.04': 'hazardous',
    '61.90.05': 'low_risk',
    '61.90.99': 'hazardous',
    '62.20.00': 'low_risk',
    '62.90.01': 'low_risk',
    '62.90.99': 'low_risk',
    '63.10.00': 'low_risk',
    '63.91.02': 'low_risk',
    '63.92.00': 'low_risk',
    '64.11.06': 'low_risk',
    '64.19.01': 'low_risk',
    '64.19.02': 'low_risk',
    '64.21.00': 'low_risk',
    '64.22.00': 'low_risk',
    '64.31.00': 'low_risk',
    '64.32.00': 'low_risk',
    '64.91.01': 'low_risk',
    '64.92.01': 'low_risk',
    '64.92.04': 'low_risk',
    '64.92.08': 'low_risk',
    '64.92.90': 'low_risk',
    '64.99.03': 'low_risk',
    '64.99.08': 'low_risk',
    '64.99.09': 'low_risk',
    '64.99.10': 'low_risk',
    '64.99.99': 'low_risk',
    '65.11.02': 'low_risk',
    '65.12.13': 'low_risk',
    '65.20.01': 'low_risk',
    '65.30.01': 'low_risk',
    '66.11.02': 'low_risk',
    '66.12.01': 'low_risk',
    '66.12.04': 'low_risk',
    '66.12.06': 'low_risk',
    '66.12.08': 'low_risk',
    '66.19.07': 'low_risk',
    '66.21.01': 'low_risk',
    '66.22.01': 'low_risk',
    '66.22.02': 'low_risk',
    '66.29.01': 'low_risk',
    '66.29.99': 'low_risk',
    '66.30.00': 'low_risk',
    '68.11.00': 'low_risk',
    '68.12.01': 'low_risk',
    '68.12.02': 'highly_hazardous',
    '68.12.03': 'highly_hazardous',
    '68.20.02': 'low_risk',
    '68.31.01': 'low_risk',
    '68.32.01': 'low_risk',
    '68.32.02': 'low_risk',
    '68.32.03': 'low_risk',
    '68.32.04': 'low_risk',
    '69.10.01': 'low_risk',
    '69.10.02': 'low_risk',
    '69.10.03': 'low_risk',
    '69.10.07': 'low_risk',
    '69.10.08': 'low_risk',
    '69.10.09': 'low_risk',
    '69.10.10': 'low_risk',
    '69.10.90': 'low_risk',
    '69.20.01': 'low_risk',
    '69.20.02': 'low_risk',
    '69.20.03': 'low_risk',
    '69.20.04': 'low_risk',
    '69.20.05': 'low_risk',
    '70.10.01': 'low_risk',
    '70.20.01': 'low_risk',
    '70.20.02': 'low_risk',
    '71.11.02': 'low_risk',
    '71.11.04': 'low_risk',
    '71.12.01': 'low_risk',
    '71.12.03': 'low_risk',
    '71.12.04': 'low_risk',
    '71.12.05': 'low_risk',
    '71.12.06': 'low_risk',
    '71.12.07': 'low_risk',
    '71.12.08': 'low_risk',
    '71.12.09': 'low_risk',
    '71.12.10': 'low_risk',
    '71.12.14': 'low_risk',
    '71.12.90': 'low_risk',
    '71.20.05': 'hazardous',
    '71.20.07': 'hazardous',
    '71.20.08': 'hazardous',
    '71.20.09': 'hazardous',
    '71.20.10': 'low_risk',
    '71.20.11': 'hazardous',
    '71.20.12': 'hazardous',
    '71.20.13': 'hazardous',
    '71.20.14': 'highly_hazardous',
    '71.20.90': 'highly_hazardous',
    '72.10.01': 'hazardous',
    '72.10.02': 'hazardous',
    '72.20.01': 'low_risk',
    '73.11.01': 'low_risk',
    '73.11.03': 'low_risk',
    '73.12.02': 'low_risk',
    '73.20.03': 'low_risk',
    '73.30.00': 'low_risk',
    '74.11.00': 'low_risk',
    '74.12.00': 'low_risk',
    '74.14.00': 'low_risk',
    '74.20.22': 'low_risk',
    '74.20.25': 'highly_hazardous',
    '74.20.26': 'low_risk',
    '74.20.27': 'low_risk',
    '74.20.28': 'low_risk',
    '74.20.29': 'low_risk',
    '74.20.90': 'low_risk',
    '74.30.12': 'low_risk',
    '74.91.00': 'low_risk',
    '74.99.01': 'low_risk',
    '74.99.02': 'low_risk',
    '74.99.03': 'low_risk',
    '74.99.04': 'low_risk',
    '74.99.99': 'low_risk',
    '75.00.02': 'hazardous',
    '75.00.04': 'hazardous',
    '77.11.01': 'low_risk',
    '77.11.02': 'low_risk',
    '77.12.01': 'low_risk',
    '77.12.02': 'low_risk',
    '77.21.02': 'low_risk',
    '77.21.04': 'low_risk',
    '77.21.90': 'low_risk',
    '77.22.01': 'low_risk',
    '77.22.02': 'low_risk',
    '77.22.03': 'low_risk',
    '77.22.99': 'low_risk',
    '77.31.01': 'low_risk',
    '77.32.01': 'low_risk',
    '77.33.01': 'low_risk',
    '77.33.02': 'low_risk',
    '77.33.03': 'low_risk',
    '77.34.01': 'low_risk',
    '77.35.01': 'low_risk',
    '77.39.01': 'low_risk',
    '77.39.02': 'low_risk',
    '77.39.03': 'low_risk',
    '77.39.04': 'low_risk',
    '77.39.05': 'low_risk',
    '77.39.06': 'low_risk',
    '77.39.07': 'low_risk',
    '77.39.99': 'low_risk',
    '77.40.01': 'low_risk',
    '77.51.00': 'low_risk',
    '77.52.00': 'low_risk',
    '78.10.01': 'low_risk',
    '78.10.04': 'low_risk',
    '78.20.02': 'low_risk',
    '79.11.01': 'low_risk',
    '79.12.01': 'low_risk',
    '79.90.01': 'low_risk',
    '79.90.99': 'low_risk',
    '80.01.01': 'hazardous',
    '80.01.02': 'low_risk',
    '80.09.01': 'low_risk',
    '80.09.99': 'low_risk',
    '81.10.01': 'hazardous',
    '81.21.01': 'low_risk',
    '81.22.03': 'highly_hazardous',
    '81.22.05': 'low_risk',
    '81.22.99': 'highly_hazardous',
    '81.23.01': 'highly_hazardous',
    '81.23.02': 'low_risk',
    '81.23.03': 'hazardous',
    '81.23.99': 'highly_hazardous',
    '81.30.06': 'low_risk',
    '82.10.01': 'low_risk',
    '82.10.02': 'low_risk',
    '82.20.01': 'low_risk',
    '82.30.02': 'low_risk',
    '82.40.01': 'low_risk',
    '82.40.99': 'low_risk',
    '82.91.00': 'low_risk',
    '82.92.01': 'hazardous',
    '82.92.05': 'highly_hazardous',
    '82.99.02': 'low_risk',
    '82.99.04': 'low_risk',
    '82.99.08': 'low_risk',
    '82.99.99': 'low_risk',
    '84.11.41': 'low_risk',
    '84.11.42': 'low_risk',
    '84.11.43': 'low_risk',
    '84.11.44': 'low_risk',
    '84.11.45': 'low_risk',
    '84.11.46': 'low_risk',
    '84.11.47': 'low_risk',
    '84.11.48': 'low_risk',
    '84.11.90': 'low_risk',
    '84.12.11': 'low_risk',
    '84.12.12': 'low_risk',
    '84.12.13': 'low_risk',
    '84.12.14': 'low_risk',
    '84.13.11': 'low_risk',
    '84.13.12': 'low_risk',
    '84.13.13': 'low_risk',
    '84.13.14': 'low_risk',
    '84.13.15': 'low_risk',
    '84.13.16': 'low_risk',
    '84.13.17': 'low_risk',
    '84.13.18': 'low_risk',
    '84.21.05': 'low_risk',
    '84.21.06': 'low_risk',
    '84.22.05': 'low_risk',
    '84.22.06': 'low_risk',
    '84.23.04': 'low_risk',
    '84.23.05': 'hazardous',
    '84.23.06': 'low_risk',
    '84.24.01': 'hazardous',
    '84.25.01': 'highly_hazardous',
    '84.25.02': 'highly_hazardous',
    '84.25.03': 'low_risk',
    '84.30.01': 'low_risk',
    '85.10.01': 'low_risk',
    '85.10.02': 'low_risk',
    '85.20.06': 'low_risk',
    '85.20.07': 'low_risk',
    '85.20.08': 'low_risk',
    '85.20.09': 'low_risk',
    '85.31.12': 'low_risk',
    '85.31.13': 'low_risk',
    '85.31.14': 'low_risk',
    '85.31.16': 'low_risk',
    '85.32.10': 'low_risk',
    '85.32.11': 'hazardous',
    '85.32.12': 'low_risk',
    '85.32.13': 'hazardous',
    '85.32.14': 'hazardous',
    '85.32.15': 'hazardous',
    '85.32.16': 'low_risk',
    '85.32.90': 'low_risk',
    '85.33.00': 'low_risk',
    '85.40.01': 'low_risk',
    '85.40.02': 'low_risk',
    '85.51.03': 'low_risk',
    '85.52.05': 'low_risk',
    '85.53.01': 'low_risk',
    '85.59.01': 'low_risk',
    '85.59.03': 'low_risk',
    '85.59.05': 'low_risk',
    '85.59.06': 'low_risk',
    '85.59.08': 'low_risk',
    '85.59.09': 'low_risk',
    '85.59.10': 'low_risk',
    '85.59.12': 'low_risk',
    '85.59.15': 'low_risk',
    '85.59.16': 'low_risk',
    '85.59.99': 'low_risk',
    '85.61.00': 'low_risk',
    '85.69.00': 'low_risk',
    '86.10.04': 'highly_hazardous',
    '86.10.05': 'highly_hazardous',
    '86.10.12': 'highly_hazardous',
    '86.10.13': 'highly_hazardous',
    '86.21.02': 'hazardous',
    '86.21.03': 'hazardous',
    '86.21.04': 'hazardous',
    '86.21.05': 'hazardous',
    '86.21.90': 'hazardous',
    '86.22.02': 'hazardous',
    '86.22.05': 'hazardous',
    '86.22.06': 'hazardous',
    '86.22.07': 'hazardous',
    '86.22.90': 'hazardous',
    '86.23.01': 'hazardous',
    '86.23.03': 'hazardous',
    '86.23.05': 'hazardous',
    '86.91.01': 'highly_hazardous',
    '86.91.02': 'highly_hazardous',
    '86.92.00': 'hazardous',
    '86.94.01': 'hazardous',
    '86.94.02': 'hazardous',
    '86.95.00': 'hazardous',
    '86.96.00': 'hazardous',
    '86.97.00': 'low_risk',
    '86.99.01': 'highly_hazardous',
    '86.99.99': 'hazardous',
    '87.10.01': 'hazardous',
    '87.20.02': 'hazardous',
    '87.30.02': 'hazardous',
    '87.91.00': 'low_risk',
    '87.99.00': 'low_risk',
    '88.10.02': 'low_risk',
    '88.91.01': 'low_risk',
    '88.99.07': 'low_risk',
    '88.99.09': 'low_risk',
    '88.99.99': 'low_risk',
    '90.11.00': 'low_risk',
    '90.12.00': 'low_risk',
    '90.13.00': 'low_risk',
    '90.20.01': 'hazardous',
    '90.20.02': 'low_risk',
    '90.20.03': 'low_risk',
    '90.20.04': 'hazardous',
    '90.20.99': 'low_risk',
    '90.31.00': 'low_risk',
    '90.39.01': 'hazardous',
    '90.39.90': 'hazardous',
    '91.11.00': 'low_risk',
    '91.12.00': 'low_risk',
    '91.21.00': 'low_risk',
    '91.22.00': 'low_risk',
    '91.30.00': 'highly_hazardous',
    '91.41.00': 'hazardous',
    '91.42.00': 'hazardous',
    '92.00.01': 'low_risk',
    '92.00.02': 'low_risk',
    '92.00.03': 'low_risk',
    '93.11.01': 'low_risk',
    '93.11.02': 'low_risk',
    '93.12.01': 'hazardous',
    '93.12.03': 'low_risk',
    '93.12.90': 'low_risk',
    '93.13.01': 'low_risk',
    '93.19.01': 'low_risk',
    '93.19.02': 'low_risk',
    '93.19.03': 'hazardous',
    '93.19.04': 'low_risk',
    '93.19.99': 'hazardous',
    '93.21.01': 'hazardous',
    '93.29.01': 'low_risk',
    '93.29.02': 'low_risk',
    '93.29.03': 'low_risk',
    '93.29.07': 'low_risk',
    '93.29.08': 'low_risk',
    '93.29.10': 'low_risk',
    '93.29.11': 'low_risk',
    '93.29.12': 'low_risk',
    '93.29.99': 'hazardous',
    '94.11.03': 'low_risk',
    '94.11.04': 'low_risk',
    '94.11.05': 'low_risk',
    '94.11.06': 'low_risk',
    '94.11.90': 'low_risk',
    '94.12.01': 'low_risk',
    '94.12.05': 'low_risk',
    '94.12.90': 'low_risk',
    '94.20.01': 'low_risk',
    '94.91.02': 'low_risk',
    '94.92.02': 'low_risk',
    '94.99.01': 'low_risk',
    '94.99.02': 'low_risk',
    '94.99.03': 'low_risk',
    '94.99.04': 'low_risk',
    '94.99.05': 'low_risk',
    '94.99.08': 'low_risk',
    '94.99.09': 'low_risk',
    '94.99.12': 'low_risk',
    '94.99.13': 'low_risk',
    '94.99.14': 'low_risk',
    '94.99.15': 'low_risk',
    '94.99.16': 'low_risk',
    '94.99.17': 'low_risk',
    '94.99.18': 'low_risk',
    '94.99.19': 'low_risk',
    '94.99.20': 'low_risk',
    '94.99.21': 'low_risk',
    '94.99.22': 'low_risk',
    '94.99.23': 'low_risk',
    '94.99.24': 'low_risk',
    '94.99.99': 'low_risk',
    '95.10.01': 'low_risk',
    '95.10.02': 'low_risk',
    '95.10.03': 'low_risk',
    '95.10.04': 'low_risk',
    '95.21.01': 'low_risk',
    '95.22.02': 'low_risk',
    '95.22.03': 'hazardous',
    '95.23.01': 'hazardous',
    '95.24.01': 'hazardous',
    '95.25.01': 'low_risk',
    '95.25.02': 'hazardous',
    '95.25.03': 'low_risk',
    '95.29.02': 'low_risk',
    '95.29.03': 'low_risk',
    '95.29.04': 'low_risk',
    '95.29.05': 'low_risk',
    '95.29.06': 'low_risk',
    '95.29.07': 'low_risk',
    '95.29.99': 'low_risk',
    '95.31.01': 'hazardous',
    '95.31.02': 'hazardous',
    '95.31.03': 'low_risk',
    '95.31.04': 'hazardous',
    '95.31.05': 'highly_hazardous',
    '95.31.06': 'low_risk',
    '95.31.07': 'hazardous',
    '95.31.08': 'hazardous',
    '95.32.00': 'hazardous',
    '95.40.00': 'low_risk',
    '96.10.01': 'hazardous',
    '96.10.02': 'low_risk',
    '96.10.03': 'highly_hazardous',
    '96.10.04': 'low_risk',
    '96.10.90': 'hazardous',
    '96.21.01': 'hazardous',
    '96.21.02': 'hazardous',
    '96.22.01': 'hazardous',
    '96.22.02': 'hazardous',
    '96.22.03': 'hazardous',
    '96.23.01': 'hazardous',
    '96.23.02': 'hazardous',
    '96.23.03': 'hazardous',
    '96.30.01': 'hazardous',
    '96.30.02': 'low_risk',
    '96.40.00': 'low_risk',
    '96.91.00': 'low_risk',
    '96.99.01': 'low_risk',
    '96.99.02': 'hazardous',
    '96.99.03': 'low_risk',
    '96.99.04': 'hazardous',
    '96.99.05': 'low_risk',
    '96.99.06': 'low_risk',
    '96.99.07': 'low_risk',
    '96.99.08': 'low_risk',
    '96.99.09': 'low_risk',
    '96.99.10': 'low_risk',
    '96.99.11': 'low_risk',
    '96.99.12': 'hazardous',
    '96.99.13': 'low_risk',
    '96.99.14': 'low_risk',
    '96.99.99': 'low_risk',
    '97.00.10': 'low_risk',
    '98.10.01': 'low_risk',
    '98.20.01': 'low_risk',
    '99.00.15': 'low_risk',
    '66.13.02': 'low_risk',
    '66.13.03': 'low_risk',
};
/**
 * "Çok Tehlikeli *" kodların dipnotu (KKDİK Ek-17 atfı — asbest içeren
 * karışım/eşya imalat, arz ve kullanım yasağı). Şerh sınıfı DEĞİŞTİRMEZ;
 * kod çok-tehlikeli kalır, metin bilgilendirmedir.
 */
exports.NACE_SERH = {
    '08.99.01': "23/6/2017 tarihli ve 30105 mükerrer sayılı Resmî Gazete’de yayımlanan Kimyasalların Kaydı, Değerlendirilmesi, İzni ve Kısıtlanması Hakkında Yönetmeliğin Ek-17'sinde yer alan tablonun altıncı satırındaki hükümlere istinaden asbest lifleri içeren karışımların ve eşyaların imalatı, piyasaya arzı ve kullanımı yasaktır.",
    '23.99.03': "23/6/2017 tarihli ve 30105 mükerrer sayılı Resmî Gazete’de yayımlanan Kimyasalların Kaydı, Değerlendirilmesi, İzni ve Kısıtlanması Hakkında Yönetmeliğin Ek-17'sinde yer alan tablonun altıncı satırındaki hükümlere istinaden asbest lifleri içeren karışımların ve eşyaların imalatı, piyasaya arzı ve kullanımı yasaktır.",
    '23.99.05': "23/6/2017 tarihli ve 30105 mükerrer sayılı Resmî Gazete’de yayımlanan Kimyasalların Kaydı, Değerlendirilmesi, İzni ve Kısıtlanması Hakkında Yönetmeliğin Ek-17'sinde yer alan tablonun altıncı satırındaki hükümlere istinaden asbest lifleri içeren karışımların ve eşyaların imalatı, piyasaya arzı ve kullanımı yasaktır.",
    '23.99.07': "23/6/2017 tarihli ve 30105 mükerrer sayılı Resmî Gazete’de yayımlanan Kimyasalların Kaydı, Değerlendirilmesi, İzni ve Kısıtlanması Hakkında Yönetmeliğin Ek-17'sinde yer alan tablonun altıncı satırındaki hükümlere istinaden asbest lifleri içeren karışımların ve eşyaların imalatı, piyasaya arzı ve kullanımı yasaktır.",
};
//# sourceMappingURL=nace-tehlike-sinifi.data.js.map